import request from '@/utils/request'

// 获取访客列表（本地接口，不再走IoT平台）
export function listVisits(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/app/visit.listVisits',
      method: 'get',
      params: {
        ...params,
        channel: 'PC'
      }
    }).then(response => {
      const res = response.data
      // 本地接口返回 visits 数组，做字段映射以兼容原IoT返回格式
      const visits = (res.visits || []).map(item => ({
        ...item,
        visitId: item.vId || item.visitId,
        name: item.vName || item.name,
        visitTypeName: item.reasonTypeName || item.visitTypeName
      }))
      resolve({
        data: visits,
        total: res.total || 0
      })
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取访客类型列表（改用字典接口）
export function listVisitTypes() {
  return new Promise((resolve, reject) => {
    request({
      url: '/callComponent/core/list',
      method: 'get',
      params: {
        name: 'visit',
        type: 'reason_type',
        page: 1,
        row: 500
      }
    }).then(response => {
      const res = response.data
      // 字典数据格式适配为 visitTypeList 格式 [{name, typeId}]
      const types = (res || []).map(item => ({
        name: item.name || item.statusName,
        typeId: item.id || item.statusCd
      }))
      resolve({
        data: types,
        total: types.length
      })
    }).catch(error => {
      reject(error)
    })
  })
}
